var idNum = 1;

Handlebars.registerHelper("idNum", function(same) {
    if(same)
        return "id" + idNum;
    else 
        return "id" + (idNum++);
});

Handlebars.registerHelper('ifCond', function (v1, operator, v2, options) {

    switch (operator) {
        case '==':
            return (v1 == v2) ? options.fn(this) : options.inverse(this);
        case '!=':
            return (v1 != v2) ? options.fn(this) : options.inverse(this);
        case '===':
            return (v1 === v2) ? options.fn(this) : options.inverse(this);
        case '<':
            return (v1 < v2) ? options.fn(this) : options.inverse(this);
        case '<=':
            return (v1 <= v2) ? options.fn(this) : options.inverse(this);
        case '>':
            return (v1 > v2) ? options.fn(this) : options.inverse(this);
        case '>=':
            return (v1 >= v2) ? options.fn(this) : options.inverse(this);
        case '&&':
            return (v1 && v2) ? options.fn(this) : options.inverse(this);
        case '||':
            return (v1 || v2) ? options.fn(this) : options.inverse(this);
        default:
            return options.inverse(this);
    }
});

Handlebars.registerHelper('ifHasRole', function (user, role, options) {
    if(typeof user == "string") {
        role = user;
        user = null;
    }
    user = user || M.CurrentUser;
    if(user.HasRole(role))
        return options.fn(this);
    else
        return options.inverse(this);
});


Handlebars.registerHelper('checked', function(val, vals) {
    if(!Array.isArray(vals) && typeof(vals) == "object") {
        vals = Object.keys(vals);
    }
    //console.log("Does " + JSON.stringify(val) + " exist in", vals);
    var ret = vals.indexOf(val) !== -1 ? new Handlebars.SafeString(" checked=\"checked\"") : "";
    //console.log(ret ? "yes" : "no");
    return ret;
});

Handlebars.registerHelper('eachkey', function(context, options) {
    var ret = "";
    var keys = Object.keys(context);
    
    for(var i = 0; i < keys.length; i++) {
        ret += options.fn(keys[i]);
    }
    
    return ret;
});

Handlebars.registerHelper('eachkvp', function(context, options) {
    var ret = "";
    var keys = Object.keys(context);
    
    for(var i = 0; i < keys.length; i++) {
        ret += options.fn({key:keys[i], value:context[keys[i]]});
    }
    
    return ret;
});

Handlebars.registerHelper('json', function(options) {
    return new Handlebars.SafeString(JSON.stringify(this));
});

Handlebars.registerHelper('toLocal', function(value, def) {
	if(!def) def = "";
	
	if(!value) {
		return def;
	}
    return moment(value).format("llll");
});

Handlebars.registerHelper('linkifyAlarm', function(id, shortid) {
	if(!shortid) shortid = id;
	var res = /\/([-\w]+)\/([-\w]+)\/([-\w]+)/.exec(id);
	var ret = null;
	if(res) {
		if(res[2] == "cron") {
			ret = "<a target=\"cronlog\" href=\"/site.html?site=" + encodeURIComponent(res[1]) + "&amp;filter=" + encodeURIComponent(res[3]) + "\">" + shortid  + "</a>";
			ret += " <a target=\"triggers\" href=\"/triggers.html?site=" + encodeURIComponent(res[1]) + "&amp;job=" + encodeURIComponent(res[3]) + "\">(trigger)</a>";
		}
	}
	if(ret) {
		ret = new Handlebars.SafeString(ret);
	} else {
		ret = id;
	}
	
	return ret;
});

var awsregions = [
{"Id":"us-east-1","Name":"US East 1 (N. Virginia)"},
{"Id":"us-east-2","Name":"US East 2 (Ohio)"},
{"Id":"us-west-1","Name":"US West 1 (N. California)"},
{"Id":"us-west-2","Name":"US West 2 (Oregon)"},
{"Id":"ap-south-1","Name":"Asia Pacific S 1 (Mumbai)"},
{"Id":"ap-southeast-1","Name":"Asia Pacific SE 1 (Singapore)"},
{"Id":"ap-southeast-2","Name":"Asia Pacific SE 2 (Sydney)"},
{"Id":"ap-northeast-1","Name":"Asia Pacific NE 1 (Tokyo)"},
{"Id":"ap-northeast-2","Name":"Asia Pacific NE 2 (Seoul)"},
{"Id":"ca-central-1","Name":"Central 1 (Canada)"},
{"Id":"eu-central-1","Name":"EU C1 (Frankfurt)"},
{"Id":"eu-west-1","Name":"EU W1 (Ireland)"},
{"Id":"eu-west-2","Name":"EU W2 (London)"},
{"Id":"sa-east-1","Name":"South America E1 (São Paulo)"}
];

Handlebars.registerHelper('regiondropdown', function(selected) {
	var ret = "";
	for(var region of awsregions) {
		ret += "<option value=\"" + region.Id + "\"";
		if(region.Id == selected) {
			ret += " selected=\"selected\"";
		}
		ret += ">" + region.Name + "</option>\r\n";
	}
	return new Handlebars.SafeString(ret);
});

Handlebars.registerHelper('dropdown', function(values, selected) {
	var ret = "";
	for(var val of values) {
		var value, label;
		
		if(typeof(val) == "object")
		{
			value = val.Value;
			label = val.Label;
		} 
		else
		{
			value = val;
			label = val;
		}
		
		ret += "<option value=\"" + value + "\"";
		if(selected == value)
		{
			ret += " selected";
		}
		ret += ">" + label + "</option>\r\n";
	}
	
	return new Handlebars.SafeString(ret);
});

Handlebars.registerHelper('moment-recent', function(options) {
	var ret = "";
	
	ret = moment(options.fn(this)).calendar(null, {
		sameDay: '[Today at] LT',
		nextDay: '[Tomorrow at] LT',
		nextWeek: 'dddd [at] LT',
		lastDay: '[Yesterday at] LT',
		lastWeek: '[Last] dddd [at] LT',
		sameElse: 'MMM D, YYYY [at] LT'
	});
	
	return new Handlebars.SafeString(ret);
});